// Input Validation Functions
export const validators = {
    isEmail(email) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    },

    isStrongPassword(password) {
        return password.length >= 8 && /[A-Z]/.test(password) && /[0-9]/.test(password);
    },

    isValidPhone(phone) {
        return /^[0-9]{10}$/.test(String(phone).replace(/\D/g, ''));
    },
    isValidTenDigitPhone(phone) {
        return /^[0-9]{10}$/.test(String(phone).replace(/\D/g, ''));
    },

    isNotEmpty(value) {
        return value && value.toString().trim().length > 0;
    },

    minLength(value, min) {
        return value && value.toString().length >= min;
    },

    maxLength(value, max) {
        return !value || value.toString().length <= max;
    },

    isNumber(value) {
        return !isNaN(value) && value !== '';
    },

    isUrl(url) {
        try {
            new URL(url);
            return true;
        } catch (e) {
            return false;
        }
    },

    validateStartupProfile(profile) {
        const errors = {};

        if (!this.isNotEmpty(profile.name)) {
            errors.name = 'Startup name is required';
        }

        if (!this.isNotEmpty(profile.foundingYear)) {
            errors.foundingYear = 'Founding year is required';
        }

        if (!this.isNotEmpty(profile.category)) {
            errors.category = 'Category is required';
        }

        if (!this.isNotEmpty(profile.problemStatement)) {
            errors.problemStatement = 'Problem statement is required';
        }

        return { isValid: Object.keys(errors).length === 0, errors };
    },
};

export default validators;
